const TraderUnitModel = {
  id: null,
  unitName: null,
  businessType: null,
  establishmentDate: null,
  countryId: null,
  stateId: null,
  street: null,
  city: null,
  zipCode: null,
  email: null,
  contactNumber: null,
  contactPerson: null,
  unitImage: null,
  imageUrl: null,
  isActive: false,
  userId: null,
};
